import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './LanguageSwitcher.css';

/**
 * LanguageSwitcher - Standalone language switcher component
 * Can be used anywhere in the app
 */
export const LanguageSwitcher = ({ variant = 'default', className = '' }) => {
  const { language, changeLanguage } = useLanguage();

  return (
    <div className={`language-switcher ${variant} ${className}`.trim()}>
      <button
        className={`lang-btn ${language === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        aria-label="English"
        type="button"
      >
        EN
      </button>
      <button
        className={`lang-btn ${language === 'ar' ? 'active' : ''}`}
        onClick={() => changeLanguage('ar')}
        aria-label="Arabic"
        type="button"
      >
        AR
      </button>
    </div>
  );
};

export default LanguageSwitcher;
